import * as React from 'react';
import { useRef } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import './ItemValueText.scss';
import classNames from 'classnames';
import { useEllipsisActive } from './useEllipsisActive';

interface ItemValueTextprops {
  id?: string;
  className?: string;
  children?: React.ReactNode;
  value?: string;
  url?: string;
  clickHandler?: () => void;
}

export const ItemValueText = (props: ItemValueTextprops) => {
  const itemValuesSpan = useRef(null);
  const popup = useEllipsisActive(itemValuesSpan);

  const element =
    props.url || props.clickHandler ? (
      <a
        onClick={
          props.clickHandler
            ? (e) => {
                e.preventDefault();
                if (props.clickHandler) {
                  props.clickHandler();
                }
              }
            : undefined
        }
        href={props.url ? props.url : '#'}
      >
        {props.value}
      </a>
    ) : (
      props.value
    );

  const itemTooltip = (
    <Tooltip id="itemTooltip">
      {element}
      {props.children}
    </Tooltip>
  );

  const classes: string = classNames({
    'item-value': true,
    'with-tooltip': popup.show,
    [props.className ?? '']: props.className !== undefined,
  });

  const itemValueElement = (
    <span id={props.id} className={classes} ref={itemValuesSpan}>
      {element}
      {props.children}
    </span>
  );

  if (!popup.show) {
    return itemValueElement;
  }

  return (
    <OverlayTrigger placement="top" overlay={itemTooltip} delay={{ show: 250, hide: 400 }}>
      {itemValueElement}
    </OverlayTrigger>
  );
};
